import { Avatar, Badge } from "antd";
import * as React from "react";
import { IUser } from "../../Models/Models";

interface IUserAvatarProps {
  user: IUser;
}

export const UserAvatar: React.SFC<IUserAvatarProps> = (props) => {
    const colorArray: Array<string> = [
        "#e5aa42",
        "#d8573f",
        "#ffbd54",
        "#eb6e51",
        "#0098a6",
        "#125b4a",
        "#66bdc6",
        "#437d6f",
        "#6240a3",
        "#434a54",
        "#715eaa",
        "#bbc0c8",
    ];

    const getInitials = (user: IUser) => {
        return user.firstName[0].toUpperCase() + user.lastName[0].toUpperCase();
    };

    const getAvatarColor = (name: string) => {
        if (name != null) {
            return colorArray[name.charCodeAt(0) % 12];
        }
        return colorArray[0];
    };

    const getBadgeColor = (
        loginStatus: number
    ): "default" | "success" | "processing" | "error" | "warning" => {
        if (loginStatus === 0) {
            return "success";
        } else if (loginStatus === 1) {
            return "warning";
        }
        return "error";
    };

    let avatar: JSX.Element = null;
    if (props.user && !props.user.profileImage) {
        avatar = (
            <Avatar
                style={{
                    backgroundColor: getAvatarColor(
                        `${props.user.firstName}${props.user.lastName}`
                    ),
                    verticalAlign: "middle",
                }}
            >
                {getInitials(props.user)}
            </Avatar>
        );
    } else if (props.user && props.user.profileImage) {
        avatar = (
            <Avatar src={"/Images/Users/Avatars/" + props.user.profileImage} />
        );
    }

    const content: JSX.Element
    = avatar && props.user.loginStatus === 0 ? (
        <Badge status={getBadgeColor(props.user.loginStatus)} offset={[-5, 5]}>
            {avatar}
        </Badge>
    ) : (
        avatar
    );

    return content;
};
